import queryString from "query-string";
import { SdkModuleName } from "@/constants/workbench";
import { getQuery } from "./query";
import { getClientID, getIntranetHost } from "@/constants";

export const checkIsInSdk = () => {
  const origin = queryString.parse(window.location.search)?.origin;
  return origin === SdkModuleName.aippt && window.self !== window.top;
};

export const getAppId = (): Promise<{ app_id: string }> => {
  const query = getQuery();
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
          const res = JSON.parse(xhr.responseText);
          if (res.data && res.data.app_id !== void 0) {
            resolve(res.data);
          } else {
            reject();
          }
        } else {
          reject();
        }
      }
    };
    xhr.open(
      "get",
      `${getIntranetHost()}/common/get_app_id?client_id=${getClientID()}`,
      true
    );

    xhr.setRequestHeader("access_token", query.accessToken || "");

    xhr.send(null);
  });
};
